import { render, staticRenderFns } from "./AamsComplaintRegInfo.vue?vue&type=template&id=7b318d97&scoped=true&"
import script from "./AamsComplaintRegInfo.vue?vue&type=script&lang=js&"
export * from "./AamsComplaintRegInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b318d97",
  null
  
)

export default component.exports